module.exports = __webpack_public_path__ + "assets/mailchimp.0e734166.svg";